import _sfc_main from './effect-value-container.vue2.js';
/* empty css                           */
import _export_sfc from '../../../_virtual/_plugin-vue_export-helper.js';

const EffectValueContainer = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-c7a527e0"]]);

export { EffectValueContainer as default };
//# sourceMappingURL=effect-value-container.js.map
